import React, { Fragment } from 'react';
import upcessLoader from '../../Assets/images/upcess-loader.gif';
import { ColorRing, ThreeDots, Triangle, TailSpin, InfinitySpin, RotatingLines, Hourglass } from 'react-loader-spinner';

const Loader = ({
    type = 'upcessLoader',
    isVisible = false,
    height = '200',
    width = '200',
    color = '#1d4ed8',
    radius = 1,
    isModal = false,
    overall = true,
    isShowGenerateContent
}) => {

    const loaderClass = isModal ? 'inset-0 position-fixed digy-bg-opacity' : 'inset-0 position-fixed digy-bg-opacity';

    // UI
    return (
        <React.Fragment>
            {
                isVisible && <div className={
                    `${overall ? `${loaderClass} page-loader` : 'modal-loader position-absolute inset-0 bg-body-tertiary '}`
                }>
                    <div className="rounded-full d-flex align-items-center justify-content-center h-100">
                        {
                            type === 'upcessLoader' &&
                            <div className='text-center'>
                                <img src={upcessLoader} alt='crm-loader' width={100} height={100} className='img-fluid' />
                                {isShowGenerateContent &&
                                    <>
                                        <div class="h1 loading loading03">
                                            <span>L</span>
                                            <span>O</span>
                                            <span>A</span>
                                            <span>D</span>
                                            <span>I</span>
                                            <span>N</span>
                                            <span>G</span>
                                        </div>
                                        <span className='fs-6 d-block'>Generating content... Please wait
                                            <span className='ps-2'>
                                                <Hourglass
                                                    visible={true}
                                                    height="16"
                                                    width="16"
                                                    ariaLabel="hourglass-loading"
                                                    wrapperStyle={{ height: 16, width: 16 }}
                                                    wrapperClass=""
                                                    colors={['#306cce', '#72a1ed']}
                                                />
                                            </span>
                                        </span>
                                    </>
                                }
                            </div>
                        }
                        {
                            type === 'threeDots' && <ThreeDots
                                visible={isVisible}
                                height={height}
                                width={width}
                                color={color}
                            />
                        }
                        {
                            type === 'triangle' && <Triangle
                                visible={isVisible}
                                height={height}
                                width={width}
                                color={color}
                            />
                        }
                        {
                            type === 'tailSpin' && <TailSpin
                                height={height}
                                width={width}
                                color={color}
                                ariaLabel="tail-spin-loading"
                                radius={radius}
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={isVisible}
                            />
                        }
                        {
                            type === 'infinitySpin' && <InfinitySpin
                                visible={true}
                                width={width}
                                color={color}
                                ariaLabel="infinity-spin-loading"
                            />
                        }
                        {
                            type === 'rotatingLines' && <RotatingLines
                                visible={true}
                                height={height}
                                width={width}
                                color={color}
                                strokeWidth="5"
                                strokeColor={color}
                                animationDuration="0.75"
                                ariaLabel="rotating-lines-loading"
                                wrapperStyle={{}}
                                wrapperClass=""
                            />
                        }
                    </div>
                </div>
            }
        </React.Fragment>
    )
}

export default Loader